<p #providedReadOnly class="sb-form-field-read-only">
    <ng-content></ng-content>
</p>
@if (!providedReadOnly.hasChildNodes()) {
    <p class="sb-form-field-read-only" [ngClass]="{'text-area-code-block-font': textKind == TextKind.CodeBlock}">{{ defaultReadOnlyMessage }}</p>
}
